
import httpService from './http.service';


class userService {
    async login(user) {
        return httpService.apiRequest('post', 'user/login', user);
    }

    async logout() {
        localStorage.removeItem('user');
    }

    async register(user) {
        return httpService.apiRequest('post', 'user/register', user);
    }
    async getUserById(id) {
        return httpService.apiRequest('get', `user/${id}`);
    }
    async listAllCompanyUsers(companyId) {
        return httpService.apiRequest('get', `user/company/${companyId}`);
    }
    async updateUser(user) {
        return httpService.apiRequest('put', `user/${user._id}`, user);
    }
    async removeUserFromCompany(userId) {
        return httpService.apiRequest('get', `user/company/remove/${userId}`);
    }
    async upadeteCompany(company) {
        return httpService.apiRequest('put', `company/${company._id}`, company);
    }
    async getCompanyByCreatorId() {
        return httpService.apiRequest('get', `company`);
    }
    async updateUserByCreator(user) {
        return httpService.apiRequest('put', `company/user/${user._id}`, user);
    }
    async deletePrevUserAvatar(userId, avatarData) {
        return httpService.apiRequest('put', `user/avatar/remove/${userId}`, avatarData)
    }
    async  getUploadLinkAndUpdateAvatar(data) {
        return httpService.apiRequest('post', 'user/avatar', data);
    }
    async  deleteCompany() {
        return httpService.apiRequest('get', 'user/delete/company');
    }

}

export default new userService();


// WEBPACK FOOTER //
// ./src/services/user.service.js